import { LeaveBalanceDTO, LeaveBalanceTableResult } from "@/models/leave-balances.model";
import apiClient from "./apiClient";


export const getAllLeaveBalanceGroupedByUser = async (year: number) => {
  try {
    console.log("get all leave balance");
    const res = await apiClient.get(`/users/leave-balances/year?year=${year}`);
    const data = res.data as LeaveBalanceTableResult[];
    return data;
  } catch (err) {
    console.log(err);
    return []
  }
}

export const generateLeaveBalanceTablePdf = async (year: number, data: LeaveBalanceTableResult[], asOf: Date) => {
  const res = await apiClient.post('/users/leave-balances/year-pdf', 
    { year, data },
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
        
      },
      responseType: "arraybuffer",
    }
  );
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const file = new File([blob], `${year}-leave-balance.pdf`, { type: 'application/pdf' });
  return URL.createObjectURL(file);
}

export const getLeaveBalancesOfUser = async (userId: number, year?: number) => {
  try {
    const res = await apiClient.get(`/users/${userId}/leave-balances?year=${year}`);
    const data = res.data as LeaveBalanceDTO[];
    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const updateLeaveBalancesTotalDays = async (
  userId: number,
  totalDayValues: Record<number, number>
) => {
  try {
    const returnVal: LeaveBalanceDTO[] = [];
    for (const [leaveTypeId, totalDays] of Object.entries(totalDayValues)) {
      console.log("id", leaveTypeId);
      const res = await apiClient.patch(
        `/users/${userId}/leave-balances/${leaveTypeId}`,
        {
          totalDays,
        }
      );
      returnVal.push(res.data);
    }
    return returnVal;
  } catch (error) {
    console.log(error);
    return [];
  }
};
